.variableLabel {
  color: var(--hcr-content-secondary-color);
}
